// extracted by mini-css-extract-plugin
module.exports = {"container_banner_button":"formview_container_banner_button__1vNSd","delete_button":"formview_delete_button__1K7bb","error":"formview_error__3RGcQ"};